
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.286 18.646c-.236 0-.477-.012-.717-.035a.749.749 0 01-.502-1.228c.643-.769.645-1.664.648-2.699.002-1.07.005-2.282.872-3.289a3.467 3.467 0 012.875-1.262l4.264-8.587A2.771 2.771 0 0121.213.027a2.79 2.79 0 012.242 4.439l-5.923 7.844a3.519 3.519 0 01-.637 3.672 7.184 7.184 0 01-5.609 2.664zm3.005-7.02a1.99 1.99 0 00-1.556.734c-.516.6-.518 1.362-.52 2.327-.002.758-.004 1.596-.295 2.425a5.727 5.727 0 003.833-2.1 2.019 2.019 0 00.379-2.165.733.733 0 01-.248-.427 1.985 1.985 0 00-.924-.676.75.75 0 01-.486-.107 1.72 1.72 0 00-.183-.011zm1.644-1.087a3.523 3.523 0 01.691.482l5.625-7.45c.199-.271.282-.609.23-.949s-.233-.64-.511-.843a1.293 1.293 0 00-1.905.445l-4.13 8.315z"}}),_c('path',{attrs:{"d":"M3.748 23.973a3.754 3.754 0 01-3.75-3.75v-12a3.754 3.754 0 013.75-3.75h9.75a.75.75 0 010 1.5h-9.75a2.252 2.252 0 00-2.25 2.25v12a2.252 2.252 0 002.25 2.25h12a2.252 2.252 0 002.25-2.25v-1.5a.75.75 0 011.5 0v1.5a3.754 3.754 0 01-3.75 3.75h-12z"}})])
          )
        }
      }
    